import React, { useState, useEffect } from "react";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { TrainingFileUploader } from "./Component/TrainingFileUploader";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";

const MyTraining = () => {
  const dispatch = useDispatch();
  const [myTrainingData, setMyTrainingData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(5);
  const [statusOpt, setStatusOpt] = useState([]);
  const [trainingSelectOption, setTrainingSelectOption] = useState([]);
  const [FileName, setFileName] = useState([]);
  const [resumeFile, setResumeFile] = useState([]);
  const [checkID, setCheckId] = useState("");

  useEffect(() => {
    dispatch(updateNavbarHeading("My Training"));

  }, []);

  const filteredData = Array.isArray(myTrainingData)
    ? myTrainingData.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];

  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
  });

  const [formTrainingData, setFormTrainingData] = useState({
    AttendeeCount: "",
    FeedbackScore: "",
    TrainingStatus_251: "",
    participantlist: "",
    ApplicationStatus_123:""

  });
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [status, setStatus] = useState("");
  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevState) => {
      const updatedData = { ...prevState, [name]: value };
      return updatedData;
    });
  };




  const handleGetData = async () => {
    SetApiStatus(undefined)
    try {
      const formattedFromDate = formData.fromDate
        ? moment(formData.fromDate).format("YYYY-MM-DD")
        : "";
      const formattedToDate = formData.toDate
        ? moment(formData.toDate).format("YYYY-MM-DD")
        : "";

      const response = await GetServiceCaller(`${API_URL}projectmanagement/my-training?P_FromDate=${formattedFromDate || ""
        }&P_ToDate=${formattedToDate || ""}&TrainingStatus=${status?.value || ""
        }`);


      SetApiStatus(response?.status)
      if (response.status === 200) {
        const trainingData = response?.data?.data?.data || [];
        setMyTrainingData(trainingData);
        document.getElementById("excel-btn")?.click();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Get current items for pagination
  const indexOfLastItem = currentPage * selectedRecordsPerPage;
  const indexOfFirstItem = indexOfLastItem - selectedRecordsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const recordsPerPageOption = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    setSelectedRecordsPerPage(newRecordsPerPage);
    setItemsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    fetchTrainingData();
  }, []);

  const fetchTrainingData = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/my-training?P_FromDate&P_ToDate&TrainingStatus`
      );

      SetApiStatus(response?.status)
      if (response.status === 200) {
        const trainingData = response?.data?.data?.data;
        setMyTrainingData(trainingData);
        //    Status List
        const statusList = response?.data?.data?.trainingstatus;
        const statusOptions = statusList.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setStatusOpt(statusOptions);
      } else {
        console.error(
          "Failed to fetch My Project. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Project:", error);
    }
  };

  const handleEdit = async (item) => {
    setShowModal(true);
    setCheckId(item.ProjectMemberID);
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/my-training/${item.ProjectMemberID}`
      );

      // Payroll Month List
      const trainingData = response?.data?.data?.trainingstatus;
      const trainingOpt =
        trainingData?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        })) || [];

      setTrainingSelectOption(trainingOpt);
      const responseData = response?.data?.data?.projectDetails;
      console.log("responseData",responseData);
      
      setFormTrainingData({
        AttendeeCount: responseData?.AttendeeCount || "",
        FeedbackScore: responseData?.FeedbackScore || "",
        ApplicationStatus_123: responseData?.ApplicationStatus_123 || "",
        TrainingStatus_251: responseData?.TrainingStatus_251 || "",
      });
      setFileName(responseData?.FileName || "");
    } catch (error) {
      console.error("API error:", error);
    }
  };

  const handleOnChange = (event) => {
    const { id, value } = event.target;
    setFormTrainingData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleSelectChange = (selectedOption) => {
    setFormTrainingData((prevData) => ({
      ...prevData,
      TrainingStatus_251: selectedOption?.value || "",
    }));
  };

  const handleFile = async (file) => {
    if (file) {
      setFileName(file.name);
      setResumeFile(file);

      setFormTrainingData((prevState) => ({
        ...prevState,
        participantlist: file, // <-- Set the file object here
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      AttendeeCount: formTrainingData.AttendeeCount,
      FeedbackScore: formTrainingData.FeedbackScore,
      TrainingStatus_251: formTrainingData.TrainingStatus_251,
      participantlist: formTrainingData.participantlist,
      ApplicationStatus_123: formTrainingData.TrainingStatus_251 == 1605 ?825:formTrainingData.TrainingStatus_251 == 1606 ?826:null,
    };
    try {
      const response = await PostFormServiceCaller(
        `${API_URL}projectmanagement/my-training/${checkID}`,
        payload,
        "put"
      );
      setShowModal(false);
      toast.success("Training Detail Update successfully");
      window.location.reload();
    } catch (err) {
      console.error("Submission error", err);
    }
  };



  const handleReset = () => {
    setFormData([])
    fetchTrainingData()
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className=" rounded bg-white" id="skill-table-area">
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <div className="me-1">
                <SearchBar
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              </div>
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}
              >
                <div className="btn-group me-2">
                  <button
                    type="button"
                    className="dropdown-toggle skill-button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    id="excel-btn"
                  >
                    <i className="bi bi-funnel-fill"></i>
                  </button>
                  <ul
                    className="dropdown-menu p-2 project-status-filter"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="row">
                      <div className="col-md-4">
                        <label className="form-label">From Date</label>
                        <CustomDatePicker
                          handleChange={(e) => handleChange(e)}
                          value={formData.fromDate}
                          name="fromDate"
                          className="form-control"
                          placeholderText="DD-MM-YYYY"
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">To Date</label>
                        <CustomDatePicker
                          handleChange={(e) => handleChange(e)}
                          value={formData.toDate}
                          name="toDate"
                          className="form-control"
                          placeholderText="DD-MM-YYYY"
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Status</label>
                        <Select
                          options={statusOpt}
                          value={status}
                          onChange={setStatus}
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="text-end">
                        <button className="custom-btn me-2" type="button" onClick={handleReset}>
                          Reset
                        </button>
                        <button className="custom-btn" onClick={handleGetData}>
                          Get Data
                        </button>
                      </div>
                    </div>
                  </ul>
                </div>
              </OverlayTrigger>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered table-hover mb-0">
              <thead id="thcolor">
                <tr>
                  <th>Client</th>
                  <th class="project-column">Project</th>
                  <th class="course-column">Course</th>
                  <th colspan="2" class="text-center">
                    Date
                  </th>
                  <th>Time Zone</th>
                  <th>Timing</th>
                  <th>POC Details</th>
                  <th colspan="2" class="text-center">
                    Attendee
                  </th>
                  <th>Status</th>
                  <th>Score</th>
                  <th>Closed Date</th>
                  <th>Action</th>
                </tr>
                <tr>
                  <th colspan="3"></th>
                  <th class="text-center">From</th>
                  <th class="text-center">To</th>
                  <th colspan="3"></th>
                  <th class="text-center">Count</th>
                  <th class="text-center">List</th>
                  <th colspan="4"></th>
                </tr>
              </thead>
              <tbody>
                {apiStatus === 200 && currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="14" className="text-center">
                      No Record Found
                    </td>
                  </tr>
                ) : apiStatus === 200 && currentItems.length != 0 ? (
                  currentItems.map((item, index) => {
                    const isClosed = item.TrainingStatus === "Closed";
                    return (
                      <tr key={index} className={isClosed ? "closed" : ""}>
                        <td>{item.CLIENT || "-"}</td>
                        <td
                          className="ellipsis-cell project-column"
                          data-bs-toggle="tooltip"
                          title={item.Project}
                        >
                          {item.Project || "-"}
                        </td>
                        <td
                          className="ellipsis-cell course-column"
                          data-bs-toggle="tooltip"
                          title={item.Course?.replace(/<[^>]+>/g, "") || "-"}
                        >
                          {item.Course?.replace(/<[^>]+>/g, "") || "-"}
                        </td>
                        <td>
                          {item.FromDate
                            ? moment(item.FromDate).format("DD-MMM-YYYY")
                            : "-"}
                        </td>
                        <td>
                          {item.ToDate
                            ? moment(item.ToDate).format("DD-MMM-YYYY")
                            : "-"}
                        </td>
                        <td>{item.TimeZone || "-"}</td>
                        <td>{item.Timing || "-"}</td>
                        <td>{item.POCDetails || "-"}</td>
                        <td className="text-center">
                          {item.AttendeeCount ?? "-"}
                        </td>
                        <td className="text-center">-</td>
                        <td>{item.TrainingStatus || "-"}</td>
                        <td>{item.FeedbackScore ?? "-"}</td>
                        <td>
                          {item.TrainingClosedDate
                            ? moment(item.TrainingClosedDate).format(
                              "DD-MMM-YYYY"
                            )
                            : "-"}
                        </td>
                        <td className="text-center">
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(item);
                            }}
                          >
                            <i className="bi bi-pencil-square"></i>
                          </span>
                        </td>
                      </tr>
                    );
                  })
                ) : apiStatus === undefined ? <tr>
                  <td colSpan="14" className="text-center">
                    <div>
                      <p>
                        <FaSpinner class="spinner" />
                        <br />
                        Loading
                      </p>
                    </div>
                  </td>
                </tr> : currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="14" className="text-center">
                      No Record Found
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
            <div className="d-flex justify-content-between mt-3">
              <div>
                <span className="d-flex">
                  Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
                  {Math.min(
                    currentPage * selectedRecordsPerPage,
                    filteredData.length
                  )}{" "}
                  of {filteredData.length} <span className="ms-1">results</span>
                  <select
                    value={selectedRecordsPerPage}
                    onChange={handleRecordsPerPage}
                    className="mx-2 form-select-sm"
                  >
                    {recordsPerPageOption.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div>
                <Pagination
                  itemsPerPage={selectedRecordsPerPage}
                  totalItems={filteredData.length}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
      style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1050
    }}
        >
          <div className="modal-dialog modal-md" role="document"    style={{
        width: "500px",
        margin: 0 
      }}>
            <div className="modal-content">
              <div className="modal-header"  style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px 8px 0 0'
        }}>
                <p style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#27568B',
            margin: '0'
          }}>
                  Update Training Detail
                </p>
                <button
                 style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '18px',
              color: '#000',
              padding: '4px',
              borderRadius: '4px',
              transition: 'all 0.2s',
              lineHeight: '1'
            }}
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
              <div className="modal-body p-2">
                <div class="container-fluid">
                  <div class="form-container">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label
                              htmlFor="AttendeeCount"
                              className="form-label"
                            >
                              Attendee Count
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="AttendeeCount"
                              value={formTrainingData.AttendeeCount}
                              onChange={handleOnChange}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <label
                            htmlFor="TrainingStatus_251"
                            className="form-label"
                          >
                            Status
                          </label>
                          <Select
                            id="TrainingStatus_251"
                            options={trainingSelectOption}
                            value={
                              trainingSelectOption.find(
                                (opt) =>
                                  opt.value ===
                                  formTrainingData.TrainingStatus_251
                              ) || null
                            }
                            onChange={handleSelectChange}
                          />
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label
                              htmlFor="FeedbackScore"
                              className="form-label"
                            >
                              Feedback Score
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="FeedbackScore"
                              value={formTrainingData.FeedbackScore}
                              onChange={handleOnChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6" style={{ marginTop: "28px" }}>
                          <TrainingFileUploader handleFile={handleFile} />
                          {FileName ? (
                            <p className="mb-0">
                              File:{" "}
                              <a
                                href={FileName}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {String(FileName).split("/").pop()}
                              </a>
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        <button
                          type="button"
                          className="cancel-btn me-2"
                          onClick={() => setShowModal(false)}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="custom-btn">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MyTraining;
